module.exports = __webpack_public_path__ + "media/images/flags/16/Liechtenstein-1c40ec809d64fd0bdfb2c22f90af4b27.png";